import {
  getConsoleFunction,
  setConsoleFunction,
} from "three";

type ThreeConsoleType = "log" | "warn" | "error";
type ThreeConsoleFunction = (
  type: ThreeConsoleType,
  message: string,
  ...params: unknown[]
) => void;

const CLOCK_DEPRECATION_WARNING =
  "THREE.Clock: This module has been deprecated. Please use THREE.Timer instead.";

let configured = false;

export const configureThreeConsoleWarnings = (): void => {
  if (configured) {
    return;
  }
  configured = true;

  const previousConsoleFunction = getConsoleFunction() as ThreeConsoleFunction | null;

  setConsoleFunction((type: ThreeConsoleType, message: string, ...params: unknown[]) => {
    if (type === "warn" && message === CLOCK_DEPRECATION_WARNING) {
      return;
    }

    if (previousConsoleFunction) {
      previousConsoleFunction(type, message, ...params);
      return;
    }

    if (type === "error") {
      console.error(message, ...params);
    } else if (type === "warn") {
      console.warn(message, ...params);
    } else {
      console.log(message, ...params);
    }
  });
};
